/** @module 项目常量模块-通用项目常量 */
export const ENV = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  PROD: 'prod',
  DEV: 'dev',
  TEST: 'test',
  PRE: 'pre',
  LOCAL: 'local',
  BUILD: 'build',
};

export const IS_FULL_URL = '://';

export const DEFAULT_LANG = 'en';

export const LANGS = ['en', 'zh', 'jp', 'ko', 'pt', 'ind'];

export const STATUS_NUM = {
  FALSE_NUM: 0,
  TRUE_NUM: 1,
};

export const METHODS = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const IMG_PLACEHOLDER = {
  S: 'https://staticintl.cloudcachetci.com/cms/backend-cms/wWxE078_wecom-temp-1242-02a467233a203a494b3b5ee398276c7a.png',
  M: 'https://staticintl.cloudcachetci.com/cms/backend-cms/wWxE078_wecom-temp-1242-02a467233a203a494b3b5ee398276c7a.png',
  L: 'https://staticintl.cloudcachetci.com/cms/backend-cms/5Zdi794_wecom-temp-7157-532968c0e205d53dba2d1e8c12446be4.jpg',
};
